import React, { useCallback, useEffect } from "react";
import { useContext } from "react";

import { Drawer, List, Badge, Button, Popconfirm } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import Services from "../../../Services/dataService";
import { Functions } from "../../Common";
import isEqual from "lodash/isEqual";
import { FilterActions } from ".";
import { HomeContext } from "../../Context";
import { isEmpty } from "lodash";

// function deepObjectIntersection(newFilter, initialState) {
// 	const result = {};

// 	for (const key1 in newFilter) {
// 		for (const key2 in initialState) {
// 			if (key1.includes(key2) || key2.includes(key1)) {
// 				const mergedKey = key1.includes(key2) ? key1 : key2;
// 				if (
// 					!Array.isArray(newFilter[key1]) &&
// 					typeof newFilter[key1] === "object" &&
// 					typeof initialState[key2] === "object"
// 				) {
// 					// Recursively call for nested objects
// 					result[mergedKey] = deepObjectIntersection(newFilter[key1], initialState[key2]);
// 				} else {
// 					// Keep only common keys at the deepest level
// 					result[mergedKey] = newFilter[key1];
// 				}
// 			}
// 		}
// 	}

// 	return result;
// }

const { Info, Error } = Functions;
function ShowSavedFilter({ visible, onClose, dispatch, currentFilter, setCurrentFilter }) {
	const [filters, setFilters] = React.useState([]);
	const [loading, setLoading] = React.useState(true);
	const { selectedPolygons, sliderValue, dispatch: homeDispatch } = useContext(HomeContext);

	const selectedSliderValue = sliderValue?.[selectedPolygons];

	const loadFilter = useCallback(
		(sliderValue, filters, currentFilter) => {
			// let result = deepObjectIntersection(filters, initialState);

			// if (!isEqual(result, filters)) {
			// 	Warning("Filter is not compatible with Current Structure. Converting into New Structure...");
			// 	Info("Update Filter Required.");
			// }
			setCurrentFilter({ filters: filters, ...currentFilter });

			dispatch({ type: FilterActions.loadFilter, value: { filters: filters } });

			if (!isEmpty(sliderValue))
				Object.entries(sliderValue)?.forEach(([key, value]) => {
					homeDispatch?.({ type: "filterPolygons", value: { value, type: key } });
				});
			if (!isEmpty(sliderValue))
				homeDispatch?.({
					type: "setObject",
					actions: {
						set: {
							sliderValue
						}
					}
				});
			Info("Filter Loaded");
			onClose(false);
		},
		[dispatch]
	);
	const updateFilter = useCallback(
		async ({ _id, title }) => {
			const { acknowledged } = await Services.updateFilter(
				currentFilter,
				_id,
				selectedSliderValue
					? {
							[selectedPolygons]: sliderValue?.[selectedPolygons]
					  }
					: {}
			);
			if (acknowledged) {
				Info("Filter Updated.");
				setCurrentFilter({ filters: currentFilter, ...{ _id, title } });
				setLoading(true);
				loadData();
			}
		},
		[dispatch, currentFilter]
	);

	const loadData = useCallback(async () => {
		const result = await Services.getCurrentUserFilters();
		if (result) {
			setFilters(result);
			setLoading(false);
		}
	}, []);

	useEffect(() => {
		if (!visible) return;
		loadData();
	}, [visible, loadData]);
	return (
		<Drawer title="Saved Filter" placement="right" onClose={() => onClose(false)} visible={visible} size="large">
			<List
				itemLayout="horizontal"
				loading={loading}
				dataSource={filters}
				renderItem={({ sliderValue: savedsliderValue, filters, title, createdAt, _id }) => {
					const actions = [
						<Button
							onClick={() => loadFilter(savedsliderValue, filters, { _id, title })}
							key="list-loadmore-load"
						>
							Load
						</Button>,
						<Popconfirm
							key="list-loadmore-update"
							placement="topLeft"
							title={`Are you sure to Update ${title} Filter  ?`}
							description={`Are you sure to Update ${title} Filter  ?`}
							onConfirm={() => updateFilter({ _id, title })}
							//   onCancel={cancel}
							okText="Yes"
							cancelText="No"
						>
							<Button>Update</Button>
						</Popconfirm>,
						<Popconfirm
							key="list-loadmore-delete"
							title={`Are you sure to Delete ${title} Filter  ?`}
							description="Are you sure to Delete  Filter  ?"
							onConfirm={async () => {
								const { acknowledged } = await Services.deleteFilter({ _id });
								if (acknowledged) onClose(false);
								else Error(`Error While Deleating Filter ${title}`);
							}}
							icon={<QuestionCircleOutlined style={{ color: "red" }} />}
							//   onCancel={cancel}
							okText="Yes"
							cancelText="No"
						>
							<Button>Delete</Button>
						</Popconfirm>
					];
					const listItem = (
						<List.Item actions={actions}>
							<List.Item.Meta
								title={<h4>{title}</h4>}
								description={`Created at: ${new Date(createdAt).toLocaleString()}`}
							/>
						</List.Item>
					);
					return isEqual(currentFilter, filters) && isEqual(sliderValue, savedsliderValue) ? (
						<Badge.Ribbon text="Matched" color={"orange"}>
							{listItem}
						</Badge.Ribbon>
					) : (
						listItem
					);
				}}
			/>
		</Drawer>
	);
}

export default ShowSavedFilter;
